class AccountStatistics {
	constructor() {
    }

    static cropStatistics(src) {

    	return {
            Summary: { 
                BrokerLeverage : src.Summary.BrokerLeverage,
                Equity : src.Summary.Equity,
                Balance : src.Summary.Balance,
                Exposure : src.Summary.Exposure,
                GrossDeposit : src.Summary.GrossDeposit,
                GrossWithdraw : src.Summary.GrossWithdraw,
                ProfitAbs : src.Summary.ProfitAbs,
                ProfitPoints : src.Summary.ProfitPoints,
                Twr : src.Summary.Twr,
                Drawdown1000 : src.Summary.Drawdown1000,
                Sharp1000 : src.Summary.Sharp1000,
                TotalDeals : src.Summary.TotalDeals,
                ProfitableDeals : src.Summary.ProfitableDeals,
                MaxLeverage : src.Summary.MaxLeverage,
                DaysTraded :  src.DailyRecords.length,
    		},
            DailyRecords: src.DailyRecords.length ? [ src.DailyRecords[src.DailyRecords.length - 1] ] : [],
            DaysTraded :  src.DailyRecords.length
    	};
    }
}

export { AccountStatistics };